import { View } from "react-native";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { paddingMedium, paddingSpacer } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const FilterNoPhotos = () => {
	const isPeople = useGatheringStore((store) => store.filterUserIds.length > 0);

	return (
		<View
			style={{
				flex: 1,
				justifyContent: "center",
				alignItems: "center",
				paddingBottom: paddingSpacer,
				width: "100%",
			}}
		>
			<Text large bold>
				{isPeople ? "Nobody here!" : "Nothing here!"}
			</Text>
			<Text
				color="TextLight"
				style={{
					marginTop: paddingMedium,
				}}
			>
				Try adjusting your filters
			</Text>
		</View>
	);
};
export default FilterNoPhotos;
